import React from 'react'
import styled from 'styled-components'
import Container from './Container'

const BadgeImg = styled.img`
  display: block;
  margin: -100px 0 -20px auto;
  height: auto;
  @media (max-width: 860px) {
    margin: -30px auto 0 auto;
    max-width: 50%;
  }
`

const Badge = ({ badge, alt, width }) => (
  <Container>
    <BadgeImg src={badge} alt={alt} width={width} />
  </Container>
)

export default Badge
